var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraRoll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c7815696ecbf1c96e6894b779456d330e{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c7815696ecbf1c96e6894b779456d330e",
    d: "M0,0H25V25H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,5.167a2.089,2.089,0,0,0-2.083-2.083H11.375V2.042A1.045,1.045,0,0,0,10.333,1H6.167A1.045,1.045,0,0,0,5.125,2.042V3.083H4.083A2.089,2.089,0,0,0,2,5.167V20.792a2.089,2.089,0,0,0,2.083,2.083h8.333A2.089,2.089,0,0,0,14.5,20.792h6.25a2.089,2.089,0,0,0,2.083-2.083V7.25A2.089,2.089,0,0,0,20.75,5.167ZM12.417,18.708H10.333V16.625h2.083Zm0-9.375H10.333V7.25h2.083Zm4.167,9.375H14.5V16.625h2.083Zm0-9.375H14.5V7.25h2.083Zm4.167,9.375H18.667V16.625H20.75Zm0-9.375H18.667V7.25H20.75Z",
    transform: "translate(0.083 0.042)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraRoll);
export default __webpack_public_path__ + "static/media/camera-roll.cf83935614088426b8cc127ed156aa66.svg";
export { ForwardRef as ReactComponent };